
export function getIdPath(mapping, idxPath) {
    return idxPath || mapping.listIdPath;
}

function mappingField(fieldMappingNode) {

    function isAttributeTrue(element, attributeName) {
        var attr = element.selectSingle(String.format('@*[local-name() = "{0}"]', attributeName));

        return attr &&
            (attr.value() === 'true' || attr.value() === '1');
    }

    var formField = fieldMappingNode.selectSingle('*[local-name() = "FormField"]'),
        sharePointColumn = fieldMappingNode.selectSingle('*[local-name() = "SharePointColumn"]');
    if (!formField) {
        throw new Error('FormField element not found.');
    }

    if (!sharePointColumn) {
        throw new Error('SharePointColumn element not found.');
    }

    return {
        sharePointColumn: sharePointColumn.value(),
        xPath: formField.value(),
        isRichText: isAttributeTrue(formField, 'IsRichText'),
        isId: isAttributeTrue(formField, 'IsId'),
        isAttachment: isAttributeTrue(formField, 'IsAttachment'),
        isDate: isAttributeTrue(formField, 'IsDate'),
        isParentId: isAttributeTrue(formField, 'IsParentId'),
        isPerson: isAttributeTrue(formField, 'IsPerson')
    };
}


function mapping(mappingNode) {
    var pathLevel = '*[local-name() = "Properties"]/*[local-name() = "Level"]';

    function getMappingLevelNode(mappingNode) {
        return mappingNode.selectSingle(pathLevel);
    }

    function selectNodeValueOrBlank(node, xPath) {
        var selectedNode = node.selectSingle(xPath);

        return selectedNode
            ? selectedNode.value()
            : '';
    }

    function getMappingLevelnumber(mappingNode) {
        var levelNode = getMappingLevelNode(mappingNode);

        if (!levelNode) {
            return 0;
        }

        var levelValue = parseInt(levelNode.value());
        if (!levelValue || Number.isNaN(levelValue)) {
            return 0;
        }

        return levelValue;
    }

    function getParentMappingName(mappingNode) {
        return selectNodeValueOrBlank(mappingNode, '*[local-name() = "Properties"]/*[local-name() = "ParentMapping"]');
    }

    function getListName(mapping) {
        var listCollection = mapping.selectSingle('.//*[local-name() = "ListCollection"]');

        if (!listCollection) {
            // Support pre-4.2 mappings
            listCollection = mapping.selectSingle('//*[local-name() = "ListCollection"]');

            if (!listCollection) {
                throw new Error("Unable to find ListCollection element in mapping.");
            }
        }

        var useName = listCollection.selectSingle('@*[local-name() = "useName"]'),
            listName = listCollection.selectSingle('@*[local-name() = "ListName"]');

        return {
            id: listCollection.value(),
            useName: useName && useName.value() === 'true',
            name: listName
                ? listName.value()
                : ''
        };
    }

    function getListIdPath(mapping) {
        var path = mapping.selectSingle('.//*[local-name() = "FormField"][@*[local-name() = "IsId"] = "true"]');

        return path
            ? path.value()
            : null;
    }

    function getRepeatingItemPath(mappingNode) {
        return mappingNode.selectSingle('.//*[local-name() = "RepeatingGroup"]').value();
    }

    function getMappingName(mappingNode) {
        return selectNodeValueOrBlank(mappingNode, '@*[local-name() = "mappingName"]');
    }

    function getSharepointListUrl(baseNode) {
        // qRules 4.2 changes the structure of the mapping file provided. 
        // However, there is still only one SharePoint List URL per mapping - that is, all lists need to be in the same site.
        return baseNode.selectSingle('//*[local-name() = "SharePointListURL"]').value();
    }

    function getIsRepeatingNode(node) {
        var isRepeating = node.selectSingle('*[local-name() = "IsRepeating"]');

        return isRepeating && (isRepeating.value() === 'true' || isRepeating.value() === '1');
    }

    function getFields() {
        return mappingNode.selectNodes('.//*[local-name() = "Mapping"]')
            .map(function (nodeItem) {
                return mappingField(nodeItem);
            });
    }

    var basePath = getRepeatingItemPath(mappingNode),
        hasBasePath = !!(basePath && $.trim(basePath).length > 0);

    return {
        baseNode: mappingNode,
        level: getMappingLevelnumber(mappingNode),
        parent: getParentMappingName(mappingNode),
        listName: getListName(mappingNode),
        listIdPath: getListIdPath(mappingNode),
        basePath: basePath,
        mappingName: getMappingName(mappingNode),
        listUrl: getSharepointListUrl(mappingNode),
        isRepeating: getIsRepeatingNode(mappingNode),
        getFields: getFields,
        hasBasePath: hasBasePath
    };
}


function mappingSource(mappingDs, mappingName) {
    const topLevelMappings = [];
    const allMappings = [];

    function getMappingNodeXPath(mappingName) {
        var mappingNodeXPath = mappingName
            ? '//Mappings[@mappingName = "' + mappingName + '"]'
            : '//*[local-name() = "Mappings"]';

        return mappingNodeXPath;
    }

    //if mapping name has been provided, try to get the correct mapping for the mapping name
    const mappingNodeXPath = getMappingNodeXPath(mappingName);
    //mapping data connection existence will be verified as part of GetDataSource
    const mappingNodes = mappingDs.selectNodes(mappingNodeXPath);

    if (!mappingNodes || mappingNodes.length === 0) {
        var namePart = mappingName
            ? String.format("Can't find mapping node for mapping name {0}.", mappingName)
            : '';

        throw new Error(String.format("Failed to get mapping. {0}", namePart));
    }

    function getChildMappings(mapping) {
        return allMappings.filter(function (mappingItem) {
            return mappingItem.level === mapping.level + 1 &&
                mapping.mappingName.toLowerCase() === mappingItem.parent.toLowerCase();
        });
    }

    for (const mappingNode of mappingNodes) {
        const m = mapping(mappingNode);

        allMappings.push(m);

        if (m.level === 0) {
            topLevelMappings.push(m);
        }
    };

    return {
        allMappings,
        topLevelMappings,
        getChildMappings,
    };
}


function validateMappingName(mappingName, source) {

    var filterMapping = source.allMappings.filter(function (mapping) {
        return mapping.mappingName === mappingName && mapping.parent;
    });

    if (mappingName && filterMapping.length > 0) {
        var error = String.format('Mapping name {0} was explicitly specified, but it has a parent mapping. ' +
            'Only top-level mappings can be explicitly specified as a parameter value.', mappingName);

        throw new Error(error);
    }
}


export {
    mappingSource,
    validateMappingName,
}